export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./smartsoft-frame.vue?vue&type=template&id=012a9763"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/smartsoft/smartsoft-frame.vue?vue&type=template&id=012a9763
// module id = 6Hid
// module chunks = 0